module.exports = __webpack_public_path__ + "img/Augsburg.52cba9bd.png";